export const OVERVIEW_TASKS_QUERY_KEY = "overviewTasks";
export const OPEN_TASKS_QUERY_KEY = "openTasks";
export const IN_PROGRESS_TASKS_QUERY_KEY = "inProgressTasks";
export const UPCOMING_TASKS_QUERY_KEY = "upcomingTasks";
export const COMPLETED_TASKS_QUERY_KEY = "completedTasks";
export const CLOSED_TASKS_QUERY_KEY = "closedTasks";
